import React from "react";
import { withRouter } from "react-router-dom";

class ErrorAlert extends React.Component {
  errorAlert = React.createRef();

  componentDidMount() {
    this.errorAlert.current.focus();
  }

  render() {
    return (
      <div ref={this.errorAlert} className="alert alert-danger" role="alert">
        {this.props.text}
      </div>
    );
  }
}

export default withRouter(ErrorAlert);






// WEBPACK FOOTER //
// ./src/components/ErrorAlert.js